import {
  DropDownList,
  DropDownListChangeEvent,
} from "@progress/kendo-react-dropdowns";
// import { promises } from "dns";
import React, { Fragment, useEffect, useState } from "react";
import ErrorMessage from "../Common/Components/ErrorMessage";
import Spinner from "../Common/Components/spinner";
import { useSelector } from "react-redux";
import { MachineInfoApi } from "./api";
import { updateParams, getParamsSelector } from "../Common/Slices/ParamSlice";

import { DeviceListApi } from "../DeviceList/api";
import MachineInfoGrid from "./MachineInfoGrid";

interface MachineInfoWidgetProps {
  id: string;
  header: string;
}

const MachineInfoWidget = (props: MachineInfoWidgetProps) => {
  const [machineInfo, updateMachineInfo] = useState(null);
  const [machineInfoLoading, updateLoadingMachineInfo] = useState(true);
  const [errorMessage, setErrorMessage] = useState(null);

  const [deviceErrorMessage, setDeviceErrorMessage] = useState(null);
  const [cadid, updateCadid] = useState(null);
  const [deviceList, updatedeviceList] = useState(null);
  const [deviceLabelList, updateDeviceLabelList] = useState([]);
  const [defaultLabel, updateDefaulLabel] = useState(null);
    const [deviceListLoading, updateLoadingDeviceList] = useState(true);
    const [noCadids, updateNoCadids] = useState(false);
  const globalParams = useSelector(getParamsSelector);

  useEffect(() => {
      if (globalParams.mainMachineSerialNo != null) {
          if (cadid != null) {
              updateLoadingMachineInfo(true);
              getMachineInfo(cadid);
          }
          if (noCadids) {
              updateLoadingMachineInfo(true);
              getMachineInfoBySerial(globalParams.mainMachineSerialNo);
          }
      }
  }, [cadid, noCadids]);

  useEffect(() => {
    if (globalParams.mainMachineSerialNo != null) {
      updateLoadingDeviceList(true);
      updateDefaulLabel(null);
      getDeviceList(globalParams.mainMachineSerialNo);
    }
  }, [globalParams.mainMachineSerialNo]);

  const getDeviceList = (m) => {
    let params: any = { machineSerial: m };
    DeviceListApi.getMachineDeviceList(params)
      .then((response: any) => {
       // console.log(response);
          if (response.length > 0) {
              const newList: any = [];
              for (var i = 0; i < response.length; i++) {
                  newList.push(response[i].deviceName);
              }
              updateDeviceLabelList(newList);
              updatedeviceList(response);
              updateDefaulLabel(newList[0]);
              updateCadid(response[0].customerAssemblyDeviceID);
          }
          else {
              updateNoCadids(true);
          }
        updateLoadingDeviceList(false);

        setDeviceErrorMessage(null);
      })
      .catch((error) => {
        updateLoadingDeviceList(false);
        setDeviceErrorMessage("Oops something went wrong, unable to get data.");

        console.log(error);
      });
  };

  const getMachineInfo = (c) => {
    let params: any = { cadid: c };
    MachineInfoApi.getMachineInfo(params)
        .then((response: any) => {
         // console.log(response)
        updateMachineInfo(response);
        updateLoadingMachineInfo(false);

        setErrorMessage(null);
      })
      .catch((error) => {
        updateLoadingMachineInfo(false);
        setErrorMessage("Oops something went wrong, unable to get data.");

        console.log(error);
      });
  };
    const getMachineInfoBySerial = (ms) => {
        let params: any = { machineSerial: ms };
        MachineInfoApi.getMachineInfoBySerial(params)
            .then((response: any) => {
                //console.log(response)
                updateMachineInfo(response);
                updateLoadingMachineInfo(false);

                setErrorMessage(null);
            })
            .catch((error) => {
                updateLoadingMachineInfo(false);
                setErrorMessage("Oops something went wrong, unable to get data.");

                console.log(error);
            });
    };
  const onChange = (event: DropDownListChangeEvent) => {
    for (var i = 0; i < deviceList.length; i++) {
      if (deviceList[i].deviceName == event.target.value) {
        updateCadid(deviceList[i].customerAssemblyDeviceID);
        getMachineInfo(deviceList[i].customerAssemblyDeviceID);
      }
    }
  };

    const renderFilter = () => {
        if (noCadids) {
            return null;
        }
    if (deviceListLoading || defaultLabel == null) {
      return <Spinner text="device list" />;
    }
    if (deviceErrorMessage != null) {
      return (
        <>
          <br />
          <ErrorMessage
            text={"No data found"}
            id={props.id}
            header={props.header}
          />
        </>
      );
    }
    return (
      <div className="k-textbox-container metricCombo">
        <label className="k-label" style={{ color: "#000", width: "300px" }}>
          Select Device
        </label>
        <DropDownList
          style={{ width: "300px" }}
          data={deviceLabelList}
          defaultValue={defaultLabel}
          onChange={onChange}
        />
      </div>
    );
  };
  const renderMachineInfo = () => {
    if (!noCadids && (deviceListLoading || defaultLabel == null)) {
      return <></>;
    }
    if (deviceErrorMessage != null) {
      return <></>;
    }
    if (machineInfoLoading) {
      return <Spinner text="Machine information" />;
    }
    if (errorMessage != null) {
      return (
        <>
          <br />
          <ErrorMessage
            text={"No data found"}
            id={props.id}
            header={props.header}
          />
        </>
      );
    }
    return <MachineInfoGrid data={machineInfo} />;
  };
  return (
    <>
      {renderFilter()}
      {renderMachineInfo()}
    </>
  );
};

export default MachineInfoWidget;
